<template>
  <div class="loan-wrap">
    <!-- <h1>请验证您的手机号</h1> -->
    <div v-if="channel_lable==='ZH'" class="loan-wrap-banner"></div>
    <div v-else class="loan-wrap-banner4"></div>
    <div class="pdlr10">
      <div class="loan-form">
        <van-cell-group :border="false">
          <van-field type="tel" maxlength="11"  @input="isSubmit" @keyup="isSubmit"  v-model="form.phone" :border="false"  placeholder="请输入手机号" />
          <van-field
            :border="false"
            v-model="form.code"
            @keyup="isSubmit"
            @input="isSubmit"
            center
            placeholder="请输入验证码"
            type="number"
            maxlength="6"
          >
            <template #button>
              <span class="codebtn" v-if="!isShowCode" @click="sendOutCode">发送验证码</span>
              <div class="codebtn" style="color: #999"  v-else>短信已发送(<van-count-down style="display:inline-block;font-size: 15px" ref="countDown"  @finish="finishCountDown" :auto-start="false" :time="time" format="ss">
                <template #default="timeData">
                  <span class="block" style="color:#999">{{ timeData.seconds}}</span>
                </template>
              </van-count-down>S)</div>
            </template>
          </van-field>
        </van-cell-group>
        <div class="btn-wrap">
          <van-button type="primary" size="large" @click="handleResult" :color="isShowBtn ? '#0294FF' : '#A8DBFF'" block>立即申请</van-button>
        </div> 
        <p><van-checkbox @change="changeCheckbox" v-model="checked">提交代表同意<router-link to="/rules/userrule">《用户协议》</router-link>，并接受合作商来电服务</van-checkbox></p> 
        <ul class="channeltip" v-if="channel_lable==='UC1'">
          <li>贷款有风险，借款需谨慎</li>
          <li>助贷机构：成都查数估科技有限公司</li>
          <li>放款资金由正规金融持牌放款机构提供</li>
          <li>版权所有：成都查数估科技有限公司</li>
          <li>ICP备案号：蜀ICP备18016639</li>
          <li>公安备案号:51000013006-18001</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Field, Button, CountDown, CellGroup, Toast, Checkbox, } from 'vant'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'loan',
  data() {
    return {
      form: {
        phone: '',
        code: ''
      },
      isShowBtn: false,
      isShowCode: false,
      time: 60000,
      checked: window.localStorage.getItem('channel')==='UC1' ? false : true,
      channel_lable: window.localStorage.getItem('channel')
      // infoData: {},
    }
  },
  computed: {
    // ...mapState({
    //   infoData(state) {
    //     return state.common['loan/paraminfo'].data
    //   }
    // }),
  },
  methods: {
    ...mapActions(['commitData', 'fetchCommon']),
    changeCheckbox() {
      this.isSubmit()
    },
    isSubmit() {
      if(this.isPhone() && this.isCode() && this.checked) {
        this.isShowBtn = true
      } else if(!this.checked) {
        this.isShowBtn = false
      } 
      else {
        this.isShowBtn = false
      }
    },
    isPhone() {
      if(this.form.phone.length !== 11) {
        return false
      }
      // if(!(/^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/.test(this.form.phone))) {
      //   return false
      // }
      return true
    },
    isCode() {
      if(this.form.code.length !== 6) {
        return false 
      }
      return true
    },
    sendOutCode() {
      if(this.isPhone()) {
        this.handleSendsms()
      }else {
        this.isShowCode = false
        this.$toast('请输入正确的手机号！')
      }
    },
    handleResult() {
      // 校验短信验证码
      const baseInfoData = JSON.parse(window.localStorage.getItem('baseInfoData'))
      if(this.checked === false) {
        this.$toast('请勾选用户协议')
      }else
      if(this.isShowBtn) {
        // console.log(this.form)
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: '0'
        });
        
        // this.$route.query.channel_lable
        const channel_lable = window.localStorage.getItem('channel')
        const loanNumber = 1
        this.commitData({
          request: 'webapi/checksms',
          path: 'webapi/checksms',
          data: Object.assign({}, this.form, {channel_lable: channel_lable}),
          onSuccess: (res) => {
            let loanParams = window.localStorage.getItem('loanParams') ? JSON.parse(window.localStorage.getItem('loanParams')) : {}
            loanParams['phone'] = this.form.phone
            window.localStorage.setItem('loanParams', JSON.stringify(loanParams))
            this.$toast.success(res.msg)
            // location.href = 'https://mh5.ichashugu.com/#/exclusive?openid=7939a9b6c18d4e513a9c0a964d8718ef'
            if(baseInfoData.city_name === '深圳' && channel_lable === 'TUIA') {
              location.href = 'https://mh5.ichashugu.com/#/exclusive?openid=7939a9b6c18d4e513a9c0a964d8718ef'
            }else {
              this.$router.push('/loan/components/vocation?channel_lable='+ channel_lable+'&loanNumber='+ loanNumber)
            }
          },
          onFail: (err) => {
            // alert(JSON.parse(err))
            this.$toast(err.msg)
          }
        })
      }else {
        this.$toast('请填写完整！')
      }
     
    },
    handleSendsms() {
      // 发送短信
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: '0'
      });
      this.commitData({
        request: 'webapi/sendsms',
        path: 'webapi/sendsms',
        data: {
          phone: this.form.phone,
          channel_lable: this.channel_lable
        },
        onSuccess: (res) => {
          // 发送验证码
          this.$toast.success(res.msg)
          this.isShowCode = true
          this.$nextTick(() => {
            this.$refs.countDown.start();
          })
        },
        onFail: (err) => {
          this.$toast(err.msg)
        }
      })
    },
    finishCountDown() {
      this.isShowCode = false
      this.$refs.countDown.reset();
      // this.$toast('倒计时结束');
    },
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [CountDown.name]: CountDown,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox
  }
}
</script>